import { Row, Col, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./slider.css";
import partner1 from "../assets/images/sliding-logo.webp";
import partner2 from "../assets/images/Logo-BC3Xabh5.webp";
import partner3 from "../assets/images/Prometric.webp";

const PartnerGrid = () => {
  const partners = [
    {
      id: 1,
      image: partner1,
      alt: "Partner 1",
      link: "https://americanacademyeg.com/",
    },
    // {
    //   id: 2,
    //   image: partner2,
    //   alt: "Partner 2",
    //   link: "https://eduvisioneg.com/",
    // },
    {
      id: 3,
      image: partner3,
      alt: "Partner 3",
      link: "https://www.prometric.com/",
    },
  ];

  return (
    <Container className="text-center">
      <h1 >        Our Partners
      </h1>
      <div className="partner-grid">
        <svg
          className="blob-svg"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#4f67b8"
            d="M38.2,-65.2C52.5,-57.9,69,-53.7,73.6,-43.3C78.1,-33,70.6,-16.5,67.1,-2C63.6,12.4,64.1,24.9,60.8,37.3C57.4,49.7,50.2,62.1,39.4,67.7C28.7,73.3,14.3,72.2,-1.1,74C-16.5,75.9,-32.9,80.7,-46.3,76.6C-59.6,72.5,-69.9,59.4,-74.1,45.1C-78.3,30.8,-76.5,15.4,-73.3,1.9C-70,-11.7,-65.5,-23.4,-59.4,-34.4C-53.2,-45.4,-45.6,-55.6,-35.5,-65.3C-25.3,-75,-12.7,-84.2,-0.3,-83.6C12,-83,23.9,-72.5,38.2,-65.2Z"
            transform="translate(100 100)"
          />
        </svg>
        {/* Text Section */}
        <div className="partner-text">
          <h3>
            We are proud to collaborate with industry leaders to deliver the
            best solutions and services for our clients.
          </h3>
        </div>

        {/* Icons Section using React-Bootstrap Grid */}
        <Container className="partner-container">
          <Row className="partner-icons">
            {partners.map((partner) => (
              <Col
                key={partner.id}
                xs={12}
                sm={6}
                md={4}
                lg={3}
                className="partner-columns"
              >
                <Link to={partner.link} target="_blank">
                  <div className="icon-item">
                    <img
                      src={partner.image}
                      alt={partner.alt}
                      className="icon-image"
                      loading="lazy"
                    />
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </Container>
  );
};

export default PartnerGrid;
